module.exports = __webpack_public_path__ + "static/media/teams.de62b3fe.svg";